// @generated by protobuf-ts 2.9.4
// @generated from protobuf file "mlmbox/client/account/account.proto" (package "mlmbox.client.account", syntax proto3)
// tslint:disable
import type { RpcTransport } from "@protobuf-ts/runtime-rpc";
import type { ServiceInfo } from "@protobuf-ts/runtime-rpc";
import { Account as Account$ } from "./account.ts";
import type { RemoteVerifyResponse } from "./account.ts";
import type { RemoteVerifyRequest } from "./account.ts";
import type { RemoteViewResponse } from "./account.ts";
import type { RemoteViewRequest } from "./account.ts";
import type { Account_Profile_Ava_File_List } from "../../types/account.ts";
import type { Account_Profile_Ava_List } from "../../types/account.ts";
import type { Account_Info } from "../../types/account.ts";
import type { Account_Id } from "../../types/account.ts";
import type { SetProfileRequest } from "./account.ts";
import type { Account_Profile } from "../../types/account.ts";
import type { Account_Profile_Ava } from "../../types/account.ts";
import type { Locale } from "../../types/locale.ts";
import type { Locale_Id } from "../../types/locale.ts";
import type { Account_Username } from "../../types/account.ts";
import type { SetLoginRequest } from "./account.ts";
import { stackIntercept } from "@protobuf-ts/runtime-rpc";
import type { Account } from "../../types/account.ts";
import type { Empty } from "../../../google/protobuf/empty.ts";
import type { UnaryCall } from "@protobuf-ts/runtime-rpc";
import type { RpcOptions } from "@protobuf-ts/runtime-rpc";
/**
 * @generated from protobuf service mlmbox.client.account.Account
 */
export interface IAccountClient {
    /**
     * @generated from protobuf rpc: Info(google.protobuf.Empty) returns (mlmbox.types.Account);
     */
    info(input: Empty, options?: RpcOptions): UnaryCall<Empty, Account>;
    /**
     * @generated from protobuf rpc: SetLogin(mlmbox.client.account.SetLoginRequest) returns (mlmbox.types.Account.Username);
     */
    setLogin(input: SetLoginRequest, options?: RpcOptions): UnaryCall<SetLoginRequest, Account_Username>;
    /**
     * @generated from protobuf rpc: SetLocale(mlmbox.types.Locale.Id) returns (mlmbox.types.Locale);
     */
    setLocale(input: Locale_Id, options?: RpcOptions): UnaryCall<Locale_Id, Locale>;
    /**
     * @generated from protobuf rpc: SetAva(mlmbox.types.Account.Profile.Ava) returns (mlmbox.types.Account.Profile);
     */
    setAva(input: Account_Profile_Ava, options?: RpcOptions): UnaryCall<Account_Profile_Ava, Account_Profile>;
    /**
     * @generated from protobuf rpc: SetProfile(mlmbox.client.account.SetProfileRequest) returns (mlmbox.types.Account.Profile);
     */
    setProfile(input: SetProfileRequest, options?: RpcOptions): UnaryCall<SetProfileRequest, Account_Profile>;
    /**
     * @generated from protobuf rpc: SetReferral(mlmbox.types.Account.Id) returns (mlmbox.types.Account.Info);
     */
    setReferral(input: Account_Id, options?: RpcOptions): UnaryCall<Account_Id, Account_Info>;
    /**
     * @generated from protobuf rpc: GetAvaFiles(mlmbox.types.Account.Profile.Ava.List) returns (mlmbox.types.Account.Profile.Ava.File.List);
     */
    getAvaFiles(input: Account_Profile_Ava_List, options?: RpcOptions): UnaryCall<Account_Profile_Ava_List, Account_Profile_Ava_File_List>;
    /**
     * @generated from protobuf rpc: RemoteView(mlmbox.client.account.RemoteViewRequest) returns (mlmbox.client.account.RemoteViewResponse);
     */
    remoteView(input: RemoteViewRequest, options?: RpcOptions): UnaryCall<RemoteViewRequest, RemoteViewResponse>;
    /**
     * @generated from protobuf rpc: RemoteVerify(mlmbox.client.account.RemoteVerifyRequest) returns (mlmbox.client.account.RemoteVerifyResponse);
     */
    remoteVerify(input: RemoteVerifyRequest, options?: RpcOptions): UnaryCall<RemoteVerifyRequest, RemoteVerifyResponse>;
}
/**
 * @generated from protobuf service mlmbox.client.account.Account
 */
export class AccountClient implements IAccountClient, ServiceInfo {
    typeName = Account$.typeName;
    methods = Account$.methods;
    options = Account$.options;
    constructor(private readonly _transport: RpcTransport) {
    }
    /**
     * @generated from protobuf rpc: Info(google.protobuf.Empty) returns (mlmbox.types.Account);
     */
    info(input: Empty, options?: RpcOptions): UnaryCall<Empty, Account> {
        const method = this.methods[0], opt = this._transport.mergeOptions(options);
        return stackIntercept<Empty, Account>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetLogin(mlmbox.client.account.SetLoginRequest) returns (mlmbox.types.Account.Username);
     */
    setLogin(input: SetLoginRequest, options?: RpcOptions): UnaryCall<SetLoginRequest, Account_Username> {
        const method = this.methods[1], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetLoginRequest, Account_Username>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetLocale(mlmbox.types.Locale.Id) returns (mlmbox.types.Locale);
     */
    setLocale(input: Locale_Id, options?: RpcOptions): UnaryCall<Locale_Id, Locale> {
        const method = this.methods[2], opt = this._transport.mergeOptions(options);
        return stackIntercept<Locale_Id, Locale>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetAva(mlmbox.types.Account.Profile.Ava) returns (mlmbox.types.Account.Profile);
     */
    setAva(input: Account_Profile_Ava, options?: RpcOptions): UnaryCall<Account_Profile_Ava, Account_Profile> {
        const method = this.methods[3], opt = this._transport.mergeOptions(options);
        return stackIntercept<Account_Profile_Ava, Account_Profile>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetProfile(mlmbox.client.account.SetProfileRequest) returns (mlmbox.types.Account.Profile);
     */
    setProfile(input: SetProfileRequest, options?: RpcOptions): UnaryCall<SetProfileRequest, Account_Profile> {
        const method = this.methods[4], opt = this._transport.mergeOptions(options);
        return stackIntercept<SetProfileRequest, Account_Profile>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: SetReferral(mlmbox.types.Account.Id) returns (mlmbox.types.Account.Info);
     */
    setReferral(input: Account_Id, options?: RpcOptions): UnaryCall<Account_Id, Account_Info> {
        const method = this.methods[5], opt = this._transport.mergeOptions(options);
        return stackIntercept<Account_Id, Account_Info>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: GetAvaFiles(mlmbox.types.Account.Profile.Ava.List) returns (mlmbox.types.Account.Profile.Ava.File.List);
     */
    getAvaFiles(input: Account_Profile_Ava_List, options?: RpcOptions): UnaryCall<Account_Profile_Ava_List, Account_Profile_Ava_File_List> {
        const method = this.methods[6], opt = this._transport.mergeOptions(options);
        return stackIntercept<Account_Profile_Ava_List, Account_Profile_Ava_File_List>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoteView(mlmbox.client.account.RemoteViewRequest) returns (mlmbox.client.account.RemoteViewResponse);
     */
    remoteView(input: RemoteViewRequest, options?: RpcOptions): UnaryCall<RemoteViewRequest, RemoteViewResponse> {
        const method = this.methods[7], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoteViewRequest, RemoteViewResponse>("unary", this._transport, method, opt, input);
    }
    /**
     * @generated from protobuf rpc: RemoteVerify(mlmbox.client.account.RemoteVerifyRequest) returns (mlmbox.client.account.RemoteVerifyResponse);
     */
    remoteVerify(input: RemoteVerifyRequest, options?: RpcOptions): UnaryCall<RemoteVerifyRequest, RemoteVerifyResponse> {
        const method = this.methods[8], opt = this._transport.mergeOptions(options);
        return stackIntercept<RemoteVerifyRequest, RemoteVerifyResponse>("unary", this._transport, method, opt, input);
    }
}
